module.exports = {
    /**
     * Add customer definitons of Date Util functions here
     * For example, to overwrite currentDate: 
     * 1. Define a currentDate function, as seen below
     * 2. Implement the custom functionality
     * The function definitions here should still take the same
     * inputs as their original definitions in DateUtil
     * 
     * currentDate: () =>{},
     * 
     * If you wish to reimplement another function, then ensure the following requirements: 
     * 1. The custom function handles the same input
     * 2. The custom function returns a JSDate object alone. 
     * 
     * If your function does not meet the above, it should be implemented as part of a custom Date module
     */
}